__turbopack_context__.v({
  "button_container": "styles-module-scss-module__LL5Ikq__button_container",
  "container": "styles-module-scss-module__LL5Ikq__container",
  "form_container": "styles-module-scss-module__LL5Ikq__form_container",
  "info_container": "styles-module-scss-module__LL5Ikq__info_container",
  "more_button": "styles-module-scss-module__LL5Ikq__more_button",
  "no_wrap": "styles-module-scss-module__LL5Ikq__no_wrap",
  "property_images": "styles-module-scss-module__LL5Ikq__property_images",
});
